import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Form, Input, Button, notification, Checkbox, Select } from "antd";
import { API_ENDPOINT_CC_DETAILS, API_ENDPOINT_UPDATE_CC_DETAILS, API_ENDPOINT_VENDORS, API_ENDPOINT_ADD_CC } from "../vendorfollowup.constants";
import { UserAddOutlined, PlusOutlined } from '@ant-design/icons';




const AddCCModal = ({ visible, onClose, onSuccess, initialData, ccId }) => {

    const [vendorList, setVendorList] = useState([]);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [includeAllOptions, setIncludeAllOptions] = useState(false);
    // const currentWorkspace = localStorage.getItem("currentWorkspace");
    const [currentWorkspace, setCurrentWorkspace] = useState(() => {
        return localStorage.getItem("currentWorkspace");
    });
    const [ccList, setCCList] = useState([])

    console.log(initialData, "initialData")

    console.log(selectAll, "selectAll")



    // useEffect(() => {
    //     if (initialData) {
    //         console.log("Setting form fields with initialData", initialData); // Debugging line
    //         form.setFieldsValue({
    //             name: initialData.name,
    //             email: initialData.email,
    //             vendors: initialData.vendors || [],
    //         });
    //         setSelectedVendors(initialData.vendors || []);
    //     }
    // }, [initialData]);
    useEffect(() => {
        if (visible && initialData?._id) {
            form.setFieldsValue({
                name: initialData.name,
                email: initialData.email,
                vendors: initialData.vendors || [],
            });
            setSelectedVendors(initialData.vendors || []);
        }
    }, [visible, initialData]);

    const handleVendorChange = (selectedItems) => {
        setSelectedVendors(selectedItems);
        setSelectAll(selectedItems.length === vendorList?.length);
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        setSelectedVendors(isChecked ? vendorList?.map((vendor) => vendor.value) : []);
        setIncludeAllOptions(e.target.checked);
    };

    const handleAllOptionsChange = (e) => {
        setIncludeAllOptions(e.target.checked);
    };

    const handleAddCC = async (values) => {
        setLoading(true);
        try {
            const authToken = localStorage.getItem("token");

            if (!authToken) {
                setLoading(false);
                notification.error({ message: "Authentication token not found." });
                return;
            }

            const payload = {
                ...values,
                vendors: selectedVendors,
                includeAllOptions,
            };

            const response = await axios.post(
                `${API_ENDPOINT_ADD_CC}${currentWorkspace}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.data.status) {
                const newRow = {
                    name: values.name,
                    email: values.email,
                    vendors: selectedVendors.join(", "),
                };
                onSuccess(newRow);
                form.resetFields();
                setSelectedVendors([]);
                setSelectAll(false);
                setIncludeAllOptions(false);
                onClose();
            } else {
                const newRow = {
                    name: values.name,
                    email: values.email,
                    vendors: selectedVendors.join(", "),
                };
                onSuccess(newRow);
                form.resetFields();
                setSelectedVendors([]);
                setSelectAll(false);
                setIncludeAllOptions(false);
                onClose();
            }
        } catch (error) {
            console.error("Error adding CC:", error);

        } finally {
            setLoading(false);
        }
    };
    const handleUpdateCC = async (values) => {
        setLoading(true);
        try {


            const payload = {
                ...values,
                vendors: selectedVendors,
                includeAllOptions,
                workspaceid: currentWorkspace,
                _id: initialData._id,
            };

            const response = await axios.post(
                API_ENDPOINT_UPDATE_CC_DETAILS,
                payload,

            );

            if (response.data.status) {
                const newRow = {
                    name: values.name,
                    email: values.email,
                    vendors: selectedVendors.join(", "),
                };
                onSuccess(newRow);
                form.resetFields();
                setSelectedVendors([]);
                setSelectAll(false);
                setIncludeAllOptions(false);
                onClose();
            } else {
                notification.error({ message: response.data.message || "Failed to update CC" });
            }
        } catch (error) {
            console.error("Error updating CC:", error);
            notification.error({ message: "Something went wrong" });
        } finally {
            setLoading(false);
        }
    };








    const fetchVendors = async () => {
        try {
            const response = await fetch(API_ENDPOINT_VENDORS, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ workspace: currentWorkspace }),
            });

            const data = await response.json();
            if (data.status === "success") {
                const formattedVendors = data.vendors.map((vendor) => ({
                    value: vendor,
                    label: vendor,
                }));

                setVendorList((prev) => {
                    const isSame =
                        prev.length === formattedVendors.length &&
                        prev.every((v, i) => v.value === formattedVendors[i].value);
                    return isSame ? prev : formattedVendors;
                });
            }
        } catch (error) {
            console.error("Error fetching vendor data:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchCCList = async () => {
        try {
            const response = await axios.post(API_ENDPOINT_CC_DETAILS, {
                workspaceid: currentWorkspace,
            });

            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                // setCCList(response.data.data);
                const newList = response.data.data;
                setCCList((prev) => {
                    const isSame = JSON.stringify(prev) === JSON.stringify(newList);
                    return isSame ? prev : newList;
                });
                const includeAll = newList[0]?.includeAllOptions === true;

                setSelectAll(includeAll);
                setIncludeAllOptions(includeAll);
                console.log("Data in fetch cc list")
            } else {
                setCCList([]);
                console.log("No data");
            }
        } catch (error) {
            console.error("Error fetching CC list:", error);
            setCCList([]);
        }
    };



    useEffect(() => {

        if (!currentWorkspace) return;
        const fetchData = async () => {
            await fetchVendors();
            await fetchCCList();
        };

        fetchData();
    }, [currentWorkspace]);







    return (
        <Modal
            // title="CC member"
            title={
                <div style={{ display: 'flex', alignItems: 'center', color: 'var(--Primary2-Blue-700, #0A8394)' }}>
                    <UserAddOutlined style={{ marginRight: 8 }} />
                    <span>CC member</span>
                </div>
            }
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={500}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={initialData?._id ? handleUpdateCC : handleAddCC}
            >
                <Form.Item
                    label={
                        <span style={{ color: 'rgba(33, 33, 33, 0.5)' }}>
                            Name<span style={{ color: '#F00', opacity: '0.5', marginLeft: 4 }}>*</span>
                        </span>
                    }
                    name="name"
                >
                    <Input placeholder="Enter Name here" />
                </Form.Item>
                <Form.Item
                    label={
                        <span style={{ color: 'rgba(33, 33, 33, 0.5)', marginTop: '6px' }}>
                            CC Email<span style={{ color: '#F00', opacity: '0.5', marginLeft: 4 }}>*</span>
                        </span>
                    }
                    name="email"
                >
                    <Input placeholder="Enter CC email address" />
                </Form.Item>
                <Form.Item
                    label={
                        <span style={{ color: 'rgba(33, 33, 33, 0.5)', marginTop: '6px' }}>
                            Vendors
                        </span>
                    }
                >
                    <Checkbox onChange={handleSelectAll} checked={selectAll}>
                        Select All
                    </Checkbox>
                    <Select
                        mode="multiple"
                        placeholder="Choose vendors here"
                        showSearch
                        optionFilterProp="children"
                        value={selectedVendors}
                        onChange={handleVendorChange}
                        style={{ width: "100%" }}
                    >
                        {vendorList.map((vendor) => (
                            <Select.Option key={vendor.value} value={vendor.value}>
                                {vendor.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item style={{ marginTop: "20px" }}>
                    {/* <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', fontSize: '16px' }}>
                        <PlusOutlined />
                        Add
                    </Button> */}
                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', fontSize: '16px' }}>
                        {initialData?._id ? 'Update' : 'Add'}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};


export default AddCCModal;
